import React, { useState } from 'react';
import { AutoPaysVService } from '../../../services/V2/gozer';
import { dateToLocal, formatMoney, handleErrorToast } from '../../shared/Functions';
import '../../../scss/UVP.scss';
import { Grid, Link } from '@material-ui/core';
import { getAutoPayments } from '../../shared/ExportFunctions';
import { CustomTable } from '../../shared/CustomTable';

export const UVPAutoPayments = ({errorToast, successToast, selectedPayment, setLoading}) => {
    const [isOnReRunPayments, setIsOnReRunPayments] = useState<boolean>(false);
    const [query, setQuery] = useState<any[]>([
        {
            property: "AutoPaymentId",
            value: selectedPayment.id
        },
        {
            property: "IsReRun",
            value: false
        }
    ]);
    const [hiddenColumns, setHiddenColumns] = useState<string[]>(['Batch ID', 'District', 'Payment Type', 'Payment Date', 'Service Fee', 'Payment Method Type', 'Confirmation Number', 'Decline/Error Reason']);
    const columns = [
        { title: 'Batch ID', field: '', render: (rowData) => selectedPayment.batchId },
        { title: 'District', field: '', render: (rowData) => rowData?.billingAccount?.districtInfo?.name },
        { title: 'Account', field: '', render: (rowData) => rowData?.billingAccount?.accountNumber },
        { title: 'Name', field: '', render: (rowData) => rowData?.billingAccount?.customer?.fullName },
        { title: 'Service Address', field: '', render: (rowData) => rowData?.billingAccount?.services[0]?.serviceAddress?.street },
        { title: 'Payment Type', field: '', render: (rowData) => "Payment" },
        { title: 'Payment Date', field: '', render: (rowData) => rowData?.transaction?.createdAt ? dateToLocal(rowData?.transaction?.createdAt).toLocaleString() : null },
        { title: 'Payment Amount', field: '', render: (rowData: any) => formatMoney(rowData.paymentAmount) },
        { title: 'Service Fee', field: '', render: (rowData: any) => formatMoney(rowData?.transaction?.serviceFeeAmount) },
        { title: 'Payment Method', field: '', render: rowData => rowData?.token?.cardType ?? rowData?.token?.achType },
        { title: 'Last 4', field: '', render: rowData => rowData?.paymentDetails?.token?.last4 ?? rowData?.token?.last4 },
        { title: 'Payment Status', field: '', render: rowData => rowData.errorCode },
        { title: 'Payment Method Type', field: '', render: rowData => rowData?.token.tokenType },
        { title: 'Confirmation Number', field: '', render: (rowData: any) => rowData?.transaction?.confirmationNumber },
        { title: 'Decline/Error Reason', field: '', render: (rowData: any) => rowData?.transaction?.error }
    ];

    const download = () => {
        setLoading(true)
        getAutoPayments(selectedPayment.id, (new Date()).toLocaleString())
            .then(x => {setLoading(false)})
            .catch(err => {
                errorToast(handleErrorToast(err))
                setLoading(false)
            })
    }

    return (
        <React.Fragment>
            <Grid style={{backgroundColor: "white", padding: "20px 0px 0px 0px"}}>
                <Grid container style={{margin: "0px 0px 0px 0px", padding: "0px", fontSize: "14px"}}>
                    <Grid item xs={1}>
                        <b>Batch ID: </b>{selectedPayment?.batchId}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Run Date: </b>{!selectedPayment?.runDate ? "N/A" : dateToLocal(selectedPayment.runDate).toLocaleDateString()}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Total Value: </b>{formatMoney(selectedPayment?.batchAmount ?? 0)}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Total Count: </b>{selectedPayment?.batchCount}
                    </Grid>
                    {selectedPayment?.hasBeenRerun &&
                        <>
                            <Grid item xs={3}>
                                <b>{!isOnReRunPayments ? "Resubmitted Payments: " : "Original Payments: "}</b><Link onClick={() => {
                                        setQuery([
                                            {
                                                property: "AutoPaymentId",
                                                value: selectedPayment.id
                                            },
                                            {
                                                property: "IsReRun",
                                                value: !isOnReRunPayments
                                            }
                                        ])
                                        setIsOnReRunPayments(!isOnReRunPayments);
                                    }} className="clickable">View</Link>
                            </Grid>
                        </>
                    }
                    <Grid item xs={2}>
                        <b>Download: </b><Link onClick={download} className="clickable">csv</Link>
                    </Grid>
                </Grid>
                <CustomTable
                    columns={columns}
                    actions={[]}
                    pageSize={15}
                    enablePaging={false}
                    refresh={false}
                    setRefresh={() => {}}
                    dataEndpoint={AutoPaysVService.autoPaysVGetPaymentResults}
                    dataSet={null}
                    title={""}
                    districtId={selectedPayment?.districtId}
                    addedQuery={query}
                    hiddenColumns={hiddenColumns}
                    setHiddenColumns={setHiddenColumns}
                    hiddenColumnsDisabled={false}
                    tableHeight={"400px"}
                    enableSearch={true}
                    searchPlaceholder={"Account Number"} />
            </Grid>
        </React.Fragment>
    );
}
